document.addEventListener('DOMContentLoaded', function() {
    const searchInput = document.getElementById('search-q');

    if(!searchInput) {
        return;
    }

    const searchInputContainer = searchInput.parentElement;
    const menuContent = document.getElementById('mega-menu-nav-content');
    const searchContent = document.getElementById('mega-menu-search-content');
    const searchResults = document.getElementById('search-results');
    const suggestedSearches = document.getElementById('suggested-searches');

    let debounceTimer = null;

    function updatePlaceholder() {
        if (window.innerWidth < 440) {
            searchInput.placeholder = 'Search';
        } else {
            searchInput.placeholder = 'Search for anything...';
        }
    }

    updatePlaceholder();
    window.addEventListener('resize', updatePlaceholder);

    function fadeOut(element, className, callback) {
        if (!element) {
            if (callback) callback();
            return;
        }
        
        element.classList.remove('fade-in');
        element.classList.add(className);
        
        setTimeout(function() {
            if (callback) callback();
        }, className === 'fade-out-fast' ? 100 : 400);
    }

    function fadeIn(element) {
        if (!element) return;
        
        element.style.display = 'block';
        element.classList.remove('fade-out', 'fade-out-fast');
        element.classList.add('fade-in');
    }

    function showLoading() {
        let loadingEl = searchInputContainer.querySelector('.search-loading');
        if (!loadingEl) {
            loadingEl = document.createElement('div');
            loadingEl.className = 'search-loading';
            searchInputContainer.appendChild(loadingEl);
        }
        loadingEl.classList.remove('fade-out', 'fade-out-fast');
        loadingEl.classList.add('fade-in-fast');
    }

    function hideLoading() {
        const loadingEl = searchInputContainer.querySelector('.search-loading');
        if (loadingEl) {
            loadingEl.classList.remove('fade-in','fade-in-fast');
            loadingEl.classList.add('fade-out');
            setTimeout(function() {
                if (loadingEl && loadingEl.parentElement) {
                    loadingEl.remove();
                }
            }, 400);
        }
    }

    function debounceSearch(query) {
        if (query.trim().length === 0) {
            hideLoading();
            fadeOut(searchContent, 'fade-out-fast', function() {
                searchResults.innerHTML = '';
                fadeIn(menuContent);
            });
            return;
        }

        fadeOut(menuContent, 'fade-out-fast', function() {
            menuContent.style.display = 'none';
            searchContent.style.display = 'block';
            fadeIn(searchContent);
        });
        
        showLoading();
        
        const formData = new FormData();
        formData.append('q', query);

        fetch('/search-api/', {
            method: 'POST',
            body: formData
        })
        .then(response => response.text())
        .then(html => {
            searchResults.innerHTML = html;
            fadeIn(searchResults);
            hideLoading();
        })
        .catch(error => {
            hideLoading();
            console.error('Search error:', error);
        });
    }

    searchInput.addEventListener('keyup', function() {
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }

        debounceTimer = setTimeout(function() {
            debounceSearch(searchInput.value);
        }, 500);
    });

    const menuOverlay = document.getElementById('mega-menu-overlay');
    const menuClose = document.getElementById('mega-menu-close');

    function clearSearch() {
        setTimeout(function() {
            searchInput.value = '';
            debounceSearch('');
        }, 400);
    }

    if (menuClose) {
        menuClose.addEventListener('click', clearSearch);
    }

    if (menuOverlay) {
        menuOverlay.addEventListener('click', function(e) {
            if (e.target === menuOverlay) {
                clearSearch();
            }
        });

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && menuOverlay.classList.contains('menu-open')) {
                clearSearch();
            }
        });
    }

});
